import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=ff17d4b2&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "menu-item.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/menu/menu-item.vue
// module id = 135
// module chunks = 0